"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fuelType = void 0;
exports.getFuelTypeName = getFuelTypeName;
exports.getFuelType = getFuelType;
const lodash_1 = __importDefault(require("lodash"));
function getFuelTypeName(val) {
    const d = lodash_1.default.find(exports.fuelType, { fuel_type: val });
    return lodash_1.default.get(d, 'name') || '';
}
function getFuelType(val) {
    const d = lodash_1.default.find(exports.fuelType, (x) => { return lodash_1.default.toLower(x.name) === lodash_1.default.toLower(val); });
    return lodash_1.default.get(d, 'fuel_type') || '';
}
exports.fuelType = [
    {
        id: 'G',
        gi_id: 6,
        fuel_type: 'G',
        value: 'G',
        name: 'Gasoline',
        pre81: true
    },
    {
        id: 'Y',
        gi_id: 12,
        fuel_type: 'Y',
        value: 'Y',
        name: 'Gas/Electric Hybrid',
        pre81: false
    },
    {
        id: 'I',
        gi_id: 14,
        fuel_type: 'I',
        value: 'I',
        name: 'Plug-in Hybrid',
        pre81: false
    },
    {
        id: 'L',
        gi_id: 4,
        fuel_type: 'L',
        value: 'L',
        name: 'Electric',
        pre81: false
    },
    {
        id: 'H',
        gi_id: 7,
        fuel_type: 'H',
        value: 'H',
        name: 'Hydrogen Fuel Cell',
        pre81: false
    },
    {
        id: 'F',
        gi_id: 5,
        fuel_type: 'F',
        value: 'F',
        name: 'Flex Fuel',
        pre81: false
    },
    {
        id: 'D',
        gi_id: 3,
        fuel_type: 'D',
        value: 'D',
        name: 'Diesel',
        pre81: true
    },
    {
        id: 'B',
        gi_id: 13,
        fuel_type: 'B',
        value: 'B',
        name: 'Bio Diesel',
        pre81: false
    },
    {
        id: 'DH',
        gi_id: 0,
        fuel_type: 'DH',
        value: 'DH',
        name: 'Diesel Hybrid',
        pre81: false
    },
    {
        id: 'N',
        gi_id: 8,
        fuel_type: 'N',
        value: 'N',
        name: 'Natural Gas',
        pre81: false
    },
    {
        id: 'P',
        gi_id: 9,
        fuel_type: 'P',
        value: 'P',
        name: 'Propane',
        pre81: true
    }
];
